module.exports = __webpack_public_path__ + "img/2.7d38dd16.png";